import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Map } from 'immutable';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { AppState } from 'src/app';
import { ApiGatewayService } from 'src/shared';

@Injectable()
/**
 * Class for Analysis entity services
 */
export class AnalysisService {
  private appConfiguration$: Observable<any>;
  private gbmAPI: string;
  constructor(
    private store: Store<AppState>,
    private apiGatewayService: ApiGatewayService,
  ) {
    this.appConfiguration$ = this.store.select('config');

    this.appConfiguration$
      .pipe(
        filter((mapShadowed: any) => Map.isMap(mapShadowed)),
        map((mapShadowed: any) => mapShadowed.get('api')),
        take(1),
      )
      .subscribe((api: string) => (this.gbmAPI = api));
  }

  getTradingSignals(data: any): Observable<any> {
    const observableResponse$: Observable<any> = this.apiGatewayService.post(
      `${this.gbmAPI}api/Analysis/GetTRulesWlMomentumView`,
      data,
    );
    return observableResponse$;
  }

  getPerformanceRisk(data: any): Observable<any> {
    const observableResponse$: Observable<any> = this.apiGatewayService.post(
      `${this.gbmAPI}api/Analysis/GetTRulesWlPerformanceRiskView`,
      data,
    );
    return observableResponse$;
  }

  getRelativeBehavior(data: any): Observable<any> {
    const observableResponse$: Observable<any> = this.apiGatewayService.post(
      `${this.gbmAPI}api/Analysis/GetTRulesWlRelativePerformanceView`,
      data,
    );
    return observableResponse$;
  }

  getTechnicalIndicator(data: any): Observable<any> {
    const observableResponse$: Observable<any> = this.apiGatewayService.post(
      `${this.gbmAPI}api/Analysis/GetTRulesWlTechnicalIndicatorsView`,
      data,
    );
    return observableResponse$;
  }

  getTechnicalModels(data: any): Observable<any> {
    const observableResponse$: Observable<any> = this.apiGatewayService.post(
      `${this.gbmAPI}api/Analysis/GetTRulesWlTechnicalModelsView`,
      data,
    );
    return observableResponse$;
  }

  getHistoricalPerformance(data: any): Observable<any> {
    const observableResponse$: Observable<any> = this.apiGatewayService.post(
      `${this.gbmAPI}api/Analysis/GetTRulesWlHistoricalPerformanceView`,
      data,
    );
    return observableResponse$;
  }

  getTrackingOpportunities(data: any): Observable<any> {
    const observableResponse$: Observable<any> = this.apiGatewayService.post(
      `${this.gbmAPI}api/Analysis/GetTechRulesOpportunities`,
      data,
    );
    return observableResponse$;
  }

  getTechAnalysisOpportunities(data: any): Observable<any> {
    const observableResponse$: Observable<any> = this.apiGatewayService.post(
      `${this.gbmAPI}api/Analysis/GetTRulesWlLastSessionView`,
      data,
    );
    return observableResponse$;
  }
}
